import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";

import DstLiveTable from "../../components/DstTable/DstLiveTable";
import ListerSearch from "../../components/Lister/ListerSearch/ListerSearch";
import { useSession } from "../../contexts/SessionContext";
import { PermissionComponent } from "../../services/PermissionGuard";
import { formatDateHumanly } from "../../services/TimeService";
import translate from "../../services/Translate";
import { Tutor, TutorLearner } from "./Tutors.d";

const Tutors = () => {
  const { language } = useSession();
  const [searchTerm, setSearchTerm] = useState("");

  const remoteUrl = useMemo(
    () => `tutors${searchTerm ? `?search=${encodeURIComponent(searchTerm)}` : ""}`,
    [searchTerm]
  );

  const columns = [
    {
      key: "id",
      name: translate(language, "GLOBAL.ID"),
      sortable: true,
    },
    {
      key: "full_name",
      name: translate(language, "GLOBAL.FULL_NAME"),
      sortable: true,
      render: (tutor: Tutor) => (
        <Link to={`/user/${tutor.id}`} className="text-decoration-none">
          {tutor.full_name}
        </Link>
      ),
    },
    {
      key: "email",
      name: translate(language, "GLOBAL.EMAIL"),
      sortable: true,
    },
    {
      key: "dt_access_start",
      name: translate(language, "PAGES.TUTORS.ACCESS_START"),
      sortable: true,
      render: (tutor: Tutor) => formatDateHumanly(language, tutor.dt_access_start),
    },
    {
      key: "dt_access_end",
      name: translate(language, "PAGES.TUTORS.ACCESS_END"),
      sortable: true,
      render: (tutor: Tutor) => formatDateHumanly(language, tutor.dt_access_end),
    },
    {
      key: "learners",
      name: translate(language, "PAGES.TUTORS.LEARNERS"),
      render: (tutor: Tutor) => (
        <div className="d-flex flex-column gap-1">
          {tutor.learners.map((learner: TutorLearner) => (
            <div key={`${learner.id}-${learner.cohort.id}`}>
              <Link to={`/user/${learner.id}`} className="text-decoration-none">
                {learner.full_name}
              </Link>
              <span className="mx-1">—</span>
              <Link to={`/cohort/${learner.cohort.id}`} className="text-decoration-none">
                {learner.cohort.name}
              </Link>
            </div>
          ))}
        </div>
      ),
    },
  ];

  return (
    <PermissionComponent neededPermission={{ methods: ["GET"], route: "/tutors" }} showFallBack>
      <div className="px-3 pt-3">
        <div className="d-flex flex-wrap gap-3 justify-content-between align-items-center mb-3">
          <h1 className="mb-0">{translate(language, "PAGES.TUTORS.TITLE")}</h1>
          <ListerSearch setSearchQuery={setSearchTerm} showSearchIcon timeDelay={500} />
        </div>
        <DstLiveTable
          columns={columns}
          pagination
          paginationResizeOptions={[20, 50, 100]}
          remote={remoteUrl}
          remoteKey="tutors"
          striped
        />
      </div>
    </PermissionComponent>
  );
};

export default Tutors;
